import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton, TextField } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';

const RecreationalForeign = ({
  questionId=ProfilerQuestionID.PREFERRED_INTERNATIONAL_DESTINATION,
  title = 'Which foreign destination would you like to visit?',
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  width='300px',
  maxWidth='300px',
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleInput = (e) => {
    const val = e.target.value.replace(/[^A-Za-z\s]/g, "");
    if (!isControlled) setInternalValue(val);
    if (onChange) onChange(val);
  };

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, justifyContent: 'space-between'  }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Box component='img' alt='Recreational Foreign' width={160}  src={PROFILER_IMAGES.indiaMap} />
          <CardHeader title={title} alignItems={'center'} />
            <TextField
            variant="outlined"
            fullWidth
            multiline
            size='small'
            value={isControlled ? value : internalValue}
            onChange={handleInput}
            placeholder='Type here'
            sx={{
            '& .MuiInputBase-root': {
              alignItems: 'flex-start',
            },
            '& .MuiInputBase-input': {
              maxHeight: '50px !important',
              overflow: 'auto',
            }
            }}
          />
        </Box>
        <CustomButton
          label={submitLabel}
          onClick={handleSubmit}
          disabled={!selectedValue}
          size='small'
          sx={{ width: '100%' }}
        />
      </Box>
    </Box>
  );
};

export default RecreationalForeign;
